export function normalizeOtp(value:string):string{
  return value.replace(/[۰-۹]/g,c=>String(c.charCodeAt(0)-1776)).replace(/[٠-٩]/g,c=>String(c.charCodeAt(0)-1632)).replace(/\D/g,'').slice(0,6);
}

type SmsCredential=Credential & {code:string};
let pending:{phone:string;controller:AbortController;promise:Promise<string|null>}|null=null;

export function cancelSmsOtp(){pending?.controller.abort();pending=null;}

// Start before sending the SMS, retaining the promise across the login route change.
export function startSmsOtp(phone:string):Promise<string|null>{
  cancelSmsOtp();
  if(typeof window==='undefined'||!window.isSecureContext||!('OTPCredential' in window)||!navigator.credentials?.get)return Promise.resolve(null);
  const controller=new AbortController();
  const timer=setTimeout(()=>controller.abort(),120000);
  let request:Promise<Credential|null>;
  try{request=navigator.credentials.get({otp:{transport:['sms']},signal:controller.signal} as CredentialRequestOptions);}
  catch{clearTimeout(timer);return Promise.resolve(null);}
  const promise=request.then(value=>{
    if(controller.signal.aborted)return null;
    const code=normalizeOtp((value as SmsCredential|null)?.code||'');
    return code.length===6?code:null;
  }).catch(()=>null).finally(()=>clearTimeout(timer));
  pending={phone,controller,promise};
  return promise;
}

export function receiveSmsOtp(phone:string){
  return pending?.phone===phone&&!pending.controller.signal.aborted?pending.promise:startSmsOtp(phone);
}
